// extracted by mini-css-extract-plugin
export var colorSquare = "_jr-0";
export var danger = "_jr-5";
export var lightPink = "_jr-8";
export var neutralBlue = "_jr-7";
export var neutralYellow = "_jr-6";
export var normal = "_jr-1";
export var primary = "_jr-2";
export var primaryLight = "_jr-3";
export var solidBlack = "_jr-g";
export var solidGreen = "_jr-b";
export var solidLightBlue = "_jr-d";
export var solidNavy = "_jr-c";
export var solidOrange = "_jr-f";
export var solidPink = "_jr-e";
export var solidRed = "_jr-9";
export var solidYellow = "_jr-a";
export var success = "_jr-4";